<!--
    Component Name: FamilyPhaseEditor
    Summary:
    Properties:
-->
<template>
    <div class="FamilyApprovalTimeline">
        <div v-for="(phase, phaseIndex) in RegionPhases" :key="phaseIndex">
            <h2>{{ phase.ProcessLabel }} <span class="red" v-if="ChangesMade">You Have Unsaved Changes!</span></h2>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-4" v-for="i in 3">
                        <div class="row" v-for="columnIndex in ColumnIndicesForPhase(i, phase)">
                            <div class="col-lg-7">
                                <p style="margin-bottom:auto;"><font-awesome-icon @click="AddDateToday(PhaseDatapoints(phase)[columnIndex].PropertyName)" :class="{ green: PhaseDatapoints(phase)[columnIndex].Value, pointer: EditMode && !PhaseDatapoints(phase)[columnIndex].Value}" :icon="['far', PhaseDatapoints(phase)[columnIndex].Value ? 'check-square' : 'square']" /> {{ PhaseDatapoints(phase)[columnIndex].Label }} <span v-b-tooltip.hover :title="PhaseDatapoints(phase)[columnIndex].Definition"> <font-awesome-icon class="info-icon" :icon="['fas', 'info-circle']" /> </span> </p>
                                <div class="col offset-1" v-if="PhaseDatapoints(phase)[columnIndex].Specifier">
                                    <b-form-group>
                                        <b-form-checkbox class="checkbox-no-overlap" v-for="specifier in PhaseDatapoints(phase)[columnIndex].Specifier" :disabled="!EditMode" @change="ChangesMadeTrue()" v-model="specifier.value" :value="true" :unchecked-value="false">{{specifier.label}}</b-form-checkbox>
                                    </b-form-group>
                                </div>
                            </div>
                            <div class="col-lg-5">
                                <p v-if="EditMode">
                                    <flat-pickr class="form-control" v-model="PhaseDatapoints(phase)[columnIndex].Value" :config="DateConfig"></flat-pickr>
                                </p>
                                <p v-else>{{formatDate(PhaseDatapoints(phase)[columnIndex].Value,'MM/DD/YY','')}}</p>
                            </div>

                            <div class="col">
                                <hr style="margin-bottom: 0px;margin-top: 0px;" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row" v-if="ChangesMade">
                <div class="col">
                    <button type="button" @click="SaveChanges()" class="form-control btn btn-success">SAVE CHANGES</button>
                </div>
                <div class="col">
                    <button type="button" @click="CancelChanges()" class="form-control btn btn-secondary">CANCEL</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faCheck } from '@fortawesome/free-solid-svg-icons';
    library.add(faCheck);
    import { faCheckSquare } from '@fortawesome/free-regular-svg-icons';
    library.add(faCheckSquare);
    import { faSquare } from '@fortawesome/free-regular-svg-icons';
    library.add(faSquare);
    import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
    library.add(faInfoCircle);
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);

    //import components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import DateEditor from '../../../../Core/ItemEditors/DateEditor';

    //import { EventBus } from '../../../../../services/event-bus.js';

    export default {
        props: [
            "EditPermissionRequirement",
            "ViewPermissionRequirement",
            "RecordId",
            "EditMode",
            "RecordData",
        ],
        data: function () {
            return {
                ChangesMade: false,
                RegionalDatapoints: {
                    "California Strong Families": [
                        {
                            ProcessLabel: "Initial Approval",
                            Datapoints: [
                                { PropertyName: "InquiryDate", Order: 1, Label: "Inquiry Date", Definition: "Date family contacts OC for the first time regarding hosting", Value: '', Specifier: '' },
                                { PropertyName: "FirstOliveCrestContactDate", Order: 2, Label: "First Olive Crest Contact Date", Definition: "", Value: '', Specifier: '' },
                                { PropertyName: "ApplicationReceived", Order: 3, Label: "Application Received", Definition: "Date that Olive Crest receives the application from the family", Value: '', Specifier: '' },
                                { PropertyName: "BackgroundCheckProcessed", Order: 4, Label: "Background Check Processed", Definition: "Date the Family's Background check is Submitted", Value: '', Specifier: '' },
                                { PropertyName: "BackgroundComplete", Order: 5, Label: "Background Check Completed", Definition: "The data that the Background Check results were received by Olive Crest", Value: '', Specifier: '' },
                                { PropertyName: "VolunteerAssessment", Order: 6, Label: "Volunteer Assessment", Definition: "The date of the Volunteer Assessment", Value: '', Specifier: '' },
                                { PropertyName: "HomeSafetyChecklist", Order: 7, Label: "Home Safety Checklist", Definition: "The date the Home Safety Checklist was Completed", Value: '', Specifier: '' },
                                { PropertyName: "VolunteerAgreement", Order: 8, Label: "Volunteer Agreement", Definition: "The date the Volunteer Agreement was Executed", Value: '', Specifier: '' },
                                { PropertyName: "DriversInformationObtained", Order: 9, Label: "Driver Information Obtained", Definition: "The date Olive Crest Obtained the Driver Information", Value: '', Specifier: '' },
                                { PropertyName: "OrientationTraining", Order: 10, Label: "Orientation Training Completed", Definition: "The date the Orientation Training is Completed", Value: '', Specifier: '' },
                                { PropertyName: "CoreTraining", Order: 11, Label: "Core Training", Definition: "The date that the Core Training is Completed", Value: '', Specifier: '' },
                                { PropertyName: "HostFamilyTraining", Order: 12, Label: "Host Family Training", Definition: "The date that the Host Family Training was Completed", Value: '', Specifier: '' },
                                { PropertyName: "MandatedReporterTraining", Order: 13, Label: "Mandated Reporter Training", Definition: "The date that the Madated Reporter Training was Completed", Value: '', Specifier: '' },
                                { PropertyName: "FamilyFriendMentoringTraining", Order: 14, Label: "Family Friend/Mentoring Training", Definition: "The data that the Family Friend / Mentoring Training was Completed", Value: '', Specifier: '' },
                                { PropertyName: "VolunteerTrainingCompleted", Order: 15, Label: "Volunteer Training", Definition: "The date the Volunteer Training was Completed", Value: '', Specifier: '' },
                                { PropertyName: "SupervisorReviewDate", Order: 16, Label: "Supervisor Review", Definition: "The date the Application File was Reviewed by Supervisor", Value: '', Specifier: '' },
                                { PropertyName: "HostFamilyApproved", Order: 17, Label: "Host Family Approved", Definition: "The date the Family was Approved to be a Host Family", Value: '', Specifier: '' },
                                { PropertyName: "FamilyFriendApproved", Order: 18, Label: "Family Friend Approved", Definition: "The date the Family was approved to be a Family Friend", Value: '', Specifier: '' },
                                { PropertyName: "AccreditationLetter", Order: 19, Label: "Accreditation Letter", Definition: "The date of the Family's Accreditation Letter", Value: '', Specifier: '' },
                            ]
                        },
                        {
                            ProcessLabel: "Ongoing Certification",
                            Datapoints: [
                                { PropertyName: "ReCertificationDate", Order: 1, Label: "Re-Certification Date", Definition: "The date by when a Family will need to be re-certified to allow them to continue hosting", Value: '', Specifier: '' },
                            ]
                        }
                    ],
                    "Nevada Early Intervention": [
                        {
                            ProcessLabel: "Initial Approval",
                            Datapoints: [
                                { PropertyName: "InquiryDate", Order: 1, Label: "Inquiry Date", Definition: "Date family contacts OC for the first time regarding hosting", Value: '', Specifier: '' },
                                { PropertyName: "FirstOliveCrestContactDate", Order: 2, Label: "First Olive Crest Contact Date", Definition: "", Value: '', Specifier: '' },
                                { PropertyName: "ApplicationReceived", Order: 3, Label: "Application Received", Definition: "Date that Olive Crest receives the application from the family", Value: '', Specifier: '' },
                                { PropertyName: "BackgroundCheckProcessed", Order: 4, Label: "Background Check Processed", Definition: "Date the Family's Background check is Submitted", Value: '', Specifier: '' },
                                { PropertyName: "BackgroundComplete", Order: 5, Label: "Background Check Completed", Definition: "The data that the Background Check results were received by Olive Crest", Value: '', Specifier: '' },
                                { PropertyName: "VolunteerAssessment", Order: 6, Label: "Volunteer Assessment", Definition: "The date of the Volunteer Assessment", Value: '', Specifier: '' },
                                { PropertyName: "HomeSafetyChecklist", Order: 7, Label: "Home Safety Checklist", Definition: "The date the Home Safety Checklist was Completed", Value: '', Specifier: '' },
                                { PropertyName: "VolunteerAgreement", Order: 8, Label: "Volunteer Agreement", Definition: "The date the Volunteer Agreement was Executed", Value: '', Specifier: '' },
                                { PropertyName: "DriversInformationObtained", Order: 9, Label: "Driver Information Obtained", Definition: "The date Olive Crest Obtained the Driver Information", Value: '', Specifier: '' },
                                { PropertyName: "OrientationTraining", Order: 10, Label: "Orientation Training Completed", Definition: "The date the Orientation Training is Completed", Value: '', Specifier: '' },
                                { PropertyName: "CoreTraining", Order: 11, Label: "Core Training", Definition: "The date that the Core Training is Completed", Value: '', Specifier: '' },
                                { PropertyName: "HostFamilyTraining", Order: 12, Label: "Host Family Training", Definition: "The date that the Host Family Training was Completed", Value: '', Specifier: '' },
                                { PropertyName: "MandatedReporterTraining", Order: 13, Label: "Mandated Reporter Training", Definition: "The date that the Madated Reporter Training was Completed", Value: '', Specifier: '' },
                                { PropertyName: "FamilyFriendMentoringTraining", Order: 14, Label: "Family Friend/Mentoring Training", Definition: "The data that the Family Friend / Mentoring Training was Completed", Value: '', Specifier: '' },
                                { PropertyName: "VolunteerTrainingCompleted", Order: 15, Label: "Volunteer Training", Definition: "The date the Volunteer Training was Completed", Value: '', Specifier: '' },
                                { PropertyName: "SupervisorReviewDate", Order: 16, Label: "Supervisor Review", Definition: "The date the Application File was Reviewed by Supervisor", Value: '', Specifier: '' },
                                { PropertyName: "HostFamilyApproved", Order: 17, Label: "Host Family Approved", Definition: "The date the Family was Approved to be a Host Family", Value: '', Specifier: '' },
                                { PropertyName: "FamilyFriendApproved", Order: 18, Label: "Family Friend Approved", Definition: "The date the Family was approved to be a Family Friend", Value: '', Specifier: '' },
                                { PropertyName: "AccreditationLetter", Order: 19, Label: "Accreditation Letter", Definition: "The date of the Family's Accreditation Letter", Value: '', Specifier: '' },
                            ]
                        }
                    ],
                    "PNW Strong Families": [
                        {
                            ProcessLabel: "Initial Approval",
                            Datapoints: [
                                { PropertyName: "InquiryDate", Order: 1, Label: "Inquiry Date", Definition: "Date family contacts OC for the first time regarding hosting", Value: '', Specifier: '' },
                                { PropertyName: "FirstOliveCrestContactDate", Order: 2, Label: "First Olive Crest Contact Date", Definition: "", Value: '', Specifier: '' },
                                { PropertyName: "ApplicationReceived", Order: 3, Label: "Application Received", Definition: "Date that Olive Crest receives the application from the family", Value: '', Specifier: '' },
                                { PropertyName: "BackgroundCheckProcessed", Order: 4, Label: "Background Check Processed", Definition: "Date the Family's Background check is Submitted", Value: '', Specifier: '' },
                                { PropertyName: "BackgroundComplete", Order: 5, Label: "Background Check Completed", Definition: "The data that the Background Check results were received by Olive Crest", Value: '', Specifier: '' },
                                { PropertyName: "VolunteerAssessment", Order: 6, Label: "Volunteer Assessment", Definition: "The date of the Volunteer Assessment", Value: '', Specifier: '' },
                                { PropertyName: "HomeSafetyChecklist", Order: 7, Label: "Home Safety Checklist", Definition: "The date the Home Safety Checklist was Completed", Value: '', Specifier: '' },
                                { PropertyName: "VolunteerAgreement", Order: 8, Label: "Volunteer Agreement", Definition: "The date the Volunteer Agreement was Executed", Value: '', Specifier: '' },
                                { PropertyName: "DriversInformationObtained", Order: 9, Label: "Driver Information Obtained", Definition: "The date Olive Crest Obtained the Driver Information", Value: '', Specifier: '' },
                                { PropertyName: "OrientationTraining", Order: 10, Label: "Orientation Training Completed", Definition: "The date the Orientation Training is Completed", Value: '', Specifier: '' },
                                { PropertyName: "CoreTraining", Order: 11, Label: "Core Training", Definition: "The date that the Core Training is Completed", Value: '', Specifier: '' },
                                { PropertyName: "HostFamilyTraining", Order: 12, Label: "Host Family Training", Definition: "The date that the Host Family Training was Completed", Value: '', Specifier: '' },
                                { PropertyName: "MandatedReporterTraining", Order: 13, Label: "Mandated Reporter Training", Definition: "The date that the Madated Reporter Training was Completed", Value: '', Specifier: '' },
                                { PropertyName: "FamilyFriendMentoringTraining", Order: 14, Label: "Family Friend/Mentoring Training", Definition: "The data that the Family Friend / Mentoring Training was Completed", Value: '', Specifier: '' },
                                { PropertyName: "VolunteerTrainingCompleted", Order: 15, Label: "Volunteer Training", Definition: "The date the Volunteer Training was Completed", Value: '', Specifier: '' },
                                { PropertyName: "SupervisorReviewDate", Order: 16, Label: "Supervisor Review", Definition: "The date the Application File was Reviewed by Supervisor", Value: '', Specifier: '' },
                                { PropertyName: "HostFamilyApproved", Order: 17, Label: "Host Family Approved", Definition: "The date the Family was Approved to be a Host Family", Value: '', Specifier: '' },
                                { PropertyName: "FamilyFriendApproved", Order: 18, Label: "Family Friend Approved", Definition: "The date the Family was approved to be a Family Friend", Value: '', Specifier: '' },
                                { PropertyName: "AccreditationLetter", Order: 19, Label: "Accreditation Letter", Definition: "The date of the Family's Accreditation Letter", Value: '', Specifier: '' },
                            ]
                        }
                    ],
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/y',
                    onClose: function (selectedDates, dateStr, instance) {
                        let vm = this;
                        if (instance.altInput.value.length < 8) { instance.clear(); vm.ChangesMadeTrue();}
                    },
                    onChange: (selectedDates, dateStr, instance) => {
                        this.ChangesMadeTrue();
                    }
                },
                
            };
        },
        methods: {
            //ADD RECORD
            AddDateToday(propertyName) {
                if (this.EditMode) {
                    let allDatapoints = this.AllRegionDatapoints;
                    let target = allDatapoints.filter(d => d.PropertyName == propertyName)[0];
                    if (target && !target.Value) {
                        let dateToday = moment().format('YYYY-MM-DD');
                        target.Value = dateToday;
                        this.ChangesMadeTrue();
                    }
                }
                
                
            },
            GetApprovalDates() {
                if (!this.RecordData || !this.RecordData.Id) return;
                let vm = this;
                this.$MasterAPI.ExecuteRequest("GET", "StrongFamilies/VolunteerFamilies/Status/GetApprovalDates", { FosterResourceFamilyID: vm.RecordData.Id }, this.GetApprovalDatesSuccess, () => { }, false);
            },
            GetApprovalDatesSuccess(response) {
                let vm = this;
                let allDatapoints = vm.AllRegionDatapoints;
                allDatapoints.forEach(function (item) {
                    item.Value = '';
                });
                response.data.data.forEach(function (item) {
                    let targetVals = allDatapoints.filter(r => r.PropertyName == item.Name);
                    if (targetVals.length > 0) {
                        targetVals[0].Value = item.EffectiveDate;
                        if (item.Specifier) {
                            targetVals[0].Specifier = JSON.parse(item.Specifier);
                        }
                    }
                });
                vm.ChangesMade = false;
            },
            SaveChanges() {
                let vm = this;
                
                let inputParams = {
                    FosterResourceFamilyID: vm.RecordData.Id,
                    ApprovalActivities: {}
                };

                this.AllRegionDatapoints.filter(r => r.Order != 0).forEach(function (item) {
                    inputParams.ApprovalActivities[item.PropertyName] = {
                        Name: item.PropertyName,
                        EffectiveDate: item.Value,
                        Specifier: JSON.stringify(item.Specifier)
                    };
                });

                this.$MasterAPI.ExecuteRequest("POST", "StrongFamilies/VolunteerFamilies/Status/SaveApprovalDates", inputParams, this.SaveChangesSuccess, () => { }, true);
            },
            SaveChangesSuccess(response) {
                 this.ChangesMade = false;
            },
            CancelChanges() {
                this.GetApprovalDates();
            },
            ChangesMadeTrue() {
                this.ChangesMade = true;
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            formatDate (value, fmt = 'D MMM YYYY', defaultValue='') {
                if (!value) {
                    return defaultValue;
                } else {
                    return moment(value, 'YYYY-MM-DD').format(fmt)
                }
            },
            PhaseDatapoints(phase) {
                return phase.Datapoints.filter(d => d.Order != 0).sort((a, b) => (a.Order > b.Order) ? 1 : -1);
            },
            ColumnIndicesForPhase(colNum, phase) {
                let datapoints = this.PhaseDatapoints(phase);
                let total = datapoints.length;
                let thirdCount = Math.ceil(total / 3);
                let output = [];
                let start, end;
                switch (colNum) {
                    case 1:
                        start = 0;
                        end = Math.min(thirdCount, total);
                        break;
                    case 2:
                        start = thirdCount;
                        end = Math.min(thirdCount * 2, total);
                        break;
                    case 3:
                        start = thirdCount * 2;
                        end = total;
                        break;
                }
                for (var i = start; i < end; i++) {
                    output.push(i);
                }
                return output;
            },
        },
        components: {
            flatPickr,
            DateEditor
        },
        computed: {
            RegionPhases: function () {
                if (!this.RecordData || !this.RecordData.SubProgramMemberships || !this.RecordData.SubProgramMemberships[0]) return [];
                let name = this.RecordData.SubProgramMemberships[0].SubProgram.Name; return this.RegionalDatapoints[name] || [];
            },
            AllRegionDatapoints: function () {
                let allDatapoints = [];
                this.RegionPhases.forEach(function (phase) {
                    allDatapoints = allDatapoints.concat(phase.Datapoints);
                });
                return allDatapoints;
            }
        },
        mounted() {
            this.GetApprovalDates();
        }
    }
</script>

<style scoped>
    
</style>
